document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("openDrawerBtn");
  const drawer = document.getElementById("vehicleDrawer");
  const overlay = document.getElementById("vehicleDrawerOverlay");
  const closeBtn = document.getElementById("closeDrawerBtn");
  const submitBtn = document.getElementById("submitVehicle");
  const selectedContainer = document.getElementById("selected-options");

  let selectedValues = {
    kitSize: null,
    doorType: null,
    roofType: null,
    materialGrade: null,
    airRelease: null,
    reds: null,
  };

  function updateButtonStates() {
    const doorTypeButtons = document.querySelectorAll(".door-type-btn");
    const roofTypeButtons = document.querySelectorAll(".roof-type-btn");
    const materialGradeButtons = document.querySelectorAll(".material-grade-btn");
    const airReleaseButtons = document.querySelectorAll(".air-release-btn");
    const redsButtons = document.querySelectorAll("#redsOptions .reds-btn"); // renamed for clarity


    if (doorTypeButtons.length > 0) {
      if (selectedValues.kitSize) {
        doorTypeButtons.forEach((btn) => (btn.disabled = false));
      } else {
        doorTypeButtons.forEach((btn) => (btn.disabled = true));
      }
    }

    if (roofTypeButtons.length > 0) {
      if (doorTypeButtons.length > 0 && selectedValues.doorType) {
        roofTypeButtons.forEach((btn) => (btn.disabled = false));
      } else if (doorTypeButtons.length == 0 && selectedValues.kitSize) {
        roofTypeButtons.forEach((btn) => (btn.disabled = false));
      } else {
        roofTypeButtons.forEach((btn) => (btn.disabled = true));
      }
    }

    if (materialGradeButtons.length > 0) {
      if (roofTypeButtons.length > 0 && selectedValues.roofType) {
        materialGradeButtons.forEach((btn) => (btn.disabled = false));
      } else if (
        doorTypeButtons.length > 0 &&
        roofTypeButtons.length == 0 &&
        selectedValues.doorType
      ) {
        materialGradeButtons.forEach((btn) => (btn.disabled = false));
      } else if (
        selectedValues.kitSize &&
        doorTypeButtons.length == 0 &&
        roofTypeButtons.length == 0
      ) {
        materialGradeButtons.forEach((btn) => (btn.disabled = false));
      } else {
        materialGradeButtons.forEach((btn) => (btn.disabled = true));
      }
    }

    if (selectedValues.materialGrade) {
      airReleaseButtons.forEach((btn) => (btn.disabled = false));
    } else {
      airReleaseButtons.forEach((btn) => (btn.disabled = true));
    }

    // Reds depends on airRelease selection
     if (redsButtons.length > 0) {
      const airReleaseGroupExists = airReleaseButtons.length > 0;
      const canEnableReds = (airReleaseGroupExists && !!selectedValues.airRelease) ||
                            (!airReleaseGroupExists && !!selectedValues.materialGrade);
      redsButtons.forEach(btn => btn.disabled = !canEnableReds);
    }
    


    // Update the submit button state
    updateSubmitButtonState();
  }

  function updateSubmitButtonState() {
    // Every rendered option group must have a selection, regardless of label markup.
    const groups = document.querySelectorAll(
      ".vehicle-form-chevronkit .button-group"
    );

    const allOptionsSelected =
      groups.length > 0 &&
      Array.from(groups).every((group) => group.querySelector("button.active"));

    if (allOptionsSelected) {
      submitBtn.classList.remove("disabled");
      submitBtn.disabled = false;
    } else {
      submitBtn.classList.add("disabled");
      submitBtn.disabled = true;
    }
  }

  let isFirstOpen = true;

  const chevronData = JSON.parse(
    document.getElementById("chevron-variant-data")?.textContent ||
      '{"optionNames":[],"variants":[]}'
  );

  // Maps a Shopify option name onto the matching key in selectedValues.
  function optionKeyFor(name) {
    const n = (name || "").toLowerCase();
    if (n.includes("kit")) return "kitSize";
    if (n.includes("door")) return "doorType";
    if (n.includes("roof")) return "roofType";
    if (n.includes("material")) return "materialGrade";
    if (n.includes("air")) return "airRelease";
    return null;
  }

  function resolveVehicleImage() {
    const match = chevronData.variants.find((v) =>
      v.options.every((val, i) => {
        const key = optionKeyFor(chevronData.optionNames[i]);
        // Options the shopper hasn't chosen yet don't narrow the match.
        return !key || !selectedValues[key] || selectedValues[key] === val;
      })
    );
    return match ? match.image : null;
  }

function updateVehicleImage(imageSrc) {
  const desktopImage = document.querySelector('.vehicle-image-chevronkit-desktop .vehicle-customizer-image');
  const mobileImage = document.querySelector('.vehicle-image-chevronkit-phone .vehicle-customizer-image');
  
  if (imageSrc) {
    if (desktopImage) desktopImage.src = imageSrc;
    if (mobileImage) mobileImage.src = imageSrc;
  }
}
  function openDrawer() {
    if (isFirstOpen) {
      document
        .querySelectorAll(
          ".kit-size-btn, .door-type-btn, .roof-type-btn, .material-grade-btn, .air-release-btn, .reds-btn"
        )
        .forEach((btn) => {
          btn.disabled = true;
        });

      document.querySelectorAll(".kit-size-btn").forEach((btn) => {
        btn.disabled = false;
      });

      isFirstOpen = false;
    } else {
      if (selectedValues.kitSize) {
        document.querySelectorAll(".kit-size-btn").forEach((btn) => {
          btn.disabled = false;

          if (btn.getAttribute("data-value") === selectedValues.kitSize) {
            btn.classList.add("active");
          }
        });
      }

      if (selectedValues.doorType) {
        document.querySelectorAll(".door-type-btn").forEach((btn) => {
          btn.disabled = false;

          if (btn.getAttribute("data-value") === selectedValues.doorType) {
            btn.classList.add("active");
          }
        });
      }

      if (selectedValues.roofType) {
        document.querySelectorAll(".roof-type-btn").forEach((btn) => {
          btn.disabled = false;

          if (btn.getAttribute("data-value") === selectedValues.roofType) {
            btn.classList.add("active");
          }
        });
      }

      if (selectedValues.materialGrade) {
        document.querySelectorAll(".material-grade-btn").forEach((btn) => {
          btn.disabled = false;

          if (btn.getAttribute("data-value") === selectedValues.materialGrade) {
            btn.classList.add("active");
          }
        });
      }

      if (selectedValues.airRelease) {
        document.querySelectorAll(".air-release-btn").forEach((btn) => {
          btn.disabled = false;

          if (btn.getAttribute("data-value") === selectedValues.airRelease) {
            btn.classList.add("active");
          }
        });
      }

      if (selectedValues.reds) {
        document.querySelectorAll("#redsOptions .reds-btn").forEach((btn) => {
          btn.disabled = false;
          if (btn.getAttribute("data-value") === selectedValues.reds) {
            btn.classList.add("active");
          }
        });
      }
    }

    updateSubmitButtonState();
    drawer.classList.add("open");
    overlay.classList.add("active");
  }

  function closeDrawer() {
    drawer.classList.remove("open");
    overlay.classList.remove("active");
  }

  openBtn?.addEventListener("click", openDrawer);
  closeBtn?.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);

  const buttonGroups = document.querySelectorAll(".button-group");

  buttonGroups.forEach((group) => {
    group.addEventListener("click", function (event) {
      if (event.target.tagName === "BUTTON" && !event.target.disabled) {
        group
          .querySelectorAll("button")
          .forEach((btn) => btn.classList.remove("active"));

        event.target.classList.add("active");

        const groupId = group.id;
        const selectedValue = event.target.getAttribute("data-value");
        if (groupId === "kitSizeOptions") {
          selectedValues.kitSize = selectedValue;
        } else if (groupId === "doorTypeOptions") {
          selectedValues.doorType = selectedValue;
        } else if (groupId === "roofTypeOptions") {
          selectedValues.roofType = selectedValue;
        } else if (groupId === "materialGradeOptions") {
          selectedValues.materialGrade = selectedValue;
        } else if (groupId === "airReleaseOptions") {
          selectedValues.airRelease = selectedValue;
        } else if (groupId === "redsOptions") { // added
          selectedValues.reds = selectedValue;
          const productInfo = document.querySelector("product-info");
          if (productInfo) {
            productInfo.selectedRedValue = selectedValue;
          }
          // Event when all selections are finalized (drawer submit)
          document.dispatchEvent(
            new CustomEvent("vehicleRedSelection:changed")
          );
        }

        updateButtonStates();
        updateVehicleImage(resolveVehicleImage());
      }
    });
  });

  submitBtn?.addEventListener("click", () => {
    const pdpButton = document.getElementById("openDrawerBtn");
    
    if (pdpButton) {
      if (selectedValues.kitSize) {
        pdpButton.setAttribute("data-kit-size", selectedValues.kitSize);
      }

      if (selectedValues.doorType) {
        pdpButton.setAttribute("data-door-type", selectedValues.doorType);
      }

      if (selectedValues.roofType) {
        pdpButton.setAttribute("data-roof-type", selectedValues.roofType);
      }

      if (selectedValues.materialGrade) {
        pdpButton.setAttribute("data-material-grade", selectedValues.materialGrade);
      }

      if (selectedValues.airRelease) {
        pdpButton.setAttribute("data-air-release", selectedValues.airRelease);
      }
        if (selectedValues.reds) {
        pdpButton.setAttribute("data-reds", selectedValues.reds);
      }

      document.querySelector(".vehicle-button-title").innerHTML = `
        ${selectedValues.kitSize ? `Kit Size: ${selectedValues.kitSize}.` : ""} 
        ${selectedValues.doorType ? `Door Type: ${selectedValues.doorType}.` : ""} 
        ${selectedValues.roofType ? `Roof Type: ${selectedValues.roofType}.` : ""} 
        ${selectedValues.materialGrade ? `Material Grade: ${selectedValues.materialGrade}.` : ""} 
        ${selectedValues.airRelease ? `Air Release: ${selectedValues.airRelease}` : ""}
        ${selectedValues.reds ? `Reds: ${selectedValues.reds}.` : ""}

        <p class='edit-vehicle'>Edit Vehicle</p>
      `;
    }

    closeDrawer();

    // Check every option first, then fire one change so product-info receives the
    // complete combination. Clicking each input separately raced overlapping
    // section fetches and left Add to cart disabled on an unmatched variant.
    const changedInputs = [];
    Object.keys(selectedValues).forEach((optionKey) => {
      const selectedValue = selectedValues[optionKey];
      if (!selectedValue) return;

      const pdpInput = document.querySelector(
        `.product-form__input input[data-option-value-id][value="${CSS.escape(
          selectedValue
        )}"]`
      );
      if (pdpInput && !pdpInput.checked) {
        pdpInput.checked = true;
        changedInputs.push(pdpInput);
      }
    });

    const addToCartButton = document.querySelector(".product-form__submit");
    if (addToCartButton) {
      addToCartButton.removeAttribute("disabled");
      addToCartButton.disabled = false;
    }

    const lastChangedInput = changedInputs[changedInputs.length - 1];
    if (lastChangedInput) {
      lastChangedInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  updateSubmitButtonState();
});